import { requestWeixinConfig } from './util';
import { wxShare } from '_lib/utils';
import { DEFAULT_SHARE_CONFIG } from '../heybox-share/default-config'

/**
 * 混入微信分享触发器，开发时确保invoke在被正确使用
 */
export function mixinWeixinShare(Vue, openAppConfig) {
  const defaultShareConfig = openAppConfig.weixinShareConfig
  const requestPromise = requestWeixinConfig().then(weixinData => {
    wxShare(weixinData, Object.assign(DEFAULT_SHARE_CONFIG, defaultShareConfig), true);
    return weixinData
  })

  const hbShareConfig = Vue.prototype.$hbShareConfig
  const callback = (newOpenAppConfig) => {
    if (newOpenAppConfig.weixinShareConfig) {
      requestPromise.then(weixinData => {
        wxShare(weixinData, Object.assign(DEFAULT_SHARE_CONFIG, newOpenAppConfig.weixinShareConfig), true);
      })
    }
  }

  hbShareConfig.addConfigUpdateCallback('open-app', callback)
}